import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "404 — Page not found | TourismIntel";
    let m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    const prev = m.getAttribute("content");
    m.setAttribute("content", "noindex");
    return () => { if (prev) m.setAttribute("content", prev); };
  }, []);

  return (
    <div data-testid="not-found-page" className="min-h-screen flex flex-col items-center justify-center bg-[#f8f9fa] px-6 text-center">
      <p className="category-tag text-xs tracking-widest uppercase text-[#8a999c] mb-4">Error 404</p>
      <h1 className="editorial-heading text-4xl sm:text-5xl text-[#191c1d] mb-4">Page not found</h1>
      <p className="text-[#6b7a7d] text-base max-w-md mb-8">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link data-testid="not-found-home-link" to="/" className="px-5 py-2.5 rounded-full bg-[#191c1d] text-white text-sm hover:opacity-85 transition-opacity">
          Go to homepage
        </Link>
        <Link data-testid="not-found-briefs-link" to="/briefs" className="px-5 py-2.5 rounded-full border border-[#bac9cc] text-[#191c1d] text-sm hover:bg-black/5 transition-colors">
          Weekly briefs
        </Link>
      </div>
    </div>
  );
}
